import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const groupBook = {
  //查询集体件预约列表
  query(params) {
    return request({
      url: REST_SERVICE.groupBook.query,
      method: 'get',
      params
    });
  },
  //根据开发商编号查详情
  getDetailsByCxbh(params) {
    return request({
      url: REST_SERVICE.groupBook.getDetailsByCxbh,
      method: 'get',
      params
    });
  },
  //改变集体房查状态
  changeStatus(params) {
    return request({
      url: REST_SERVICE.groupBook.changeStatus,
      method: 'post',
      params
    });
  },
  //下载文件
  fileDetail(params) {
    return request({
      url: REST_SERVICE.groupBook.fileDetail,
      method: 'get',
      params
    });
  }
};
export default groupBook;
